import React from 'react';
import { ChevronRight, Send, TrendingUp } from '../../../../shared/assets/AppIcons';
import { Badge } from '@/shared/ui/badge';
import { Button } from '@/shared/ui/button';
import { Card, CardContent } from '@/shared/ui/card';

export default function SuggestedAutomationCard({ automation, onRequest }) {
  const IconComponent = automation.icona;

  return (
    <Card className="border-[var(--border)] hover:border-[var(--warning-border)] hover:shadow-md transition-all cursor-pointer group">
      <CardContent className="p-5">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-[var(--warning-soft)] rounded-xl flex items-center justify-center group-hover:bg-[var(--warning-soft)] transition-colors">
            <IconComponent className="text-[var(--warning-text)]" size={16} />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-1">
              <h3 className="font-bold text-[var(--text-primary)]">{automation.nome}</h3>
              <Badge variant="outline" className="text-xs">
                {automation.categoria}
              </Badge>
            </div>
            <p className="text-sm text-[var(--text-secondary)] mb-3">{automation.descrizione}</p>

            <div className="flex items-center justify-between">
              <div className="flex gap-4">
                <div>
                  <p className="text-xs text-[var(--text-secondary)]">Tempo risparmiato</p>
                  <p className="text-sm font-semibold text-[var(--success-text)]">{automation.tempoRisparmiato}</p>
                </div>
                <div>
                  <p className="text-xs text-[var(--text-secondary)]">Costo stimato</p>
                  <p className="text-sm font-semibold text-[var(--text-primary)]">{automation.costoStimato}</p>
                </div>
              </div>
              <div className="flex items-center gap-1 text-xs text-[var(--text-secondary)]">
                <TrendingUp size={16} />
                {automation.popolarita}% popolarita
              </div>
            </div>

            <div className="mt-3 pt-3 border-t border-[var(--border)]">
              <Button className="w-full bg-[var(--warning)] hover:bg-[var(--warning)] text-[var(--on-primary)]" size="sm" onClick={() => onRequest(automation)}>
                <Send size={16} className="mr-2" />
                Richiedi
                <ChevronRight size={16} className="ml-auto" />
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
